import { IProjectMetadata, IR23Report, IR23ReportMetadata } from '@/interfaces/report';
import { designStore, lccaStore, projectStore } from '@/store/store';
import {
  getAcOverlayDesignFromR23Report,
  getAsphaltDesignFromR23Report,
  getConcreteDesignFromR23Report,
  getPorousDesignFromR23Report,
} from '@/modules/design/lib/r23ToSuiteTransformers';
import { getLccaFromR23Report } from '@/modules/lcca/lib/r23ToSuiteTransformers';

export const convertReportContents = async function (r23Metadata: IR23ReportMetadata,
                                                     r23Report: IR23Report,
                                                     projectMetadata: IProjectMetadata,
                                                     force: Boolean) {
  /*
  Identify which types of reports can/should be generated from the report and produce versions for the Suite
   */

  r23Metadata.conversion_started = true;

  // ID Scenarios
  const baseScenarioType = r23Report.pavementType;
  console.log(`Base Design Scenario: |${baseScenarioType}|`);

  // if (!r23Metadata.conversion_done_design || force) {
  // if (true) {
  // Convert Design
  let newScenario: any = null;

  switch (baseScenarioType) {
    case 'New - Asphalt':
      console.log('Converting Asphalt');
      newScenario = designStore.saveNewAsphaltScenario(getAsphaltDesignFromR23Report(r23Metadata, r23Report, projectMetadata.id));
      break;
    case 'New - Concrete':
      console.log('Converting Concrete');
      newScenario = designStore.saveNewConcreteScenario(getConcreteDesignFromR23Report(r23Metadata, r23Report, projectMetadata.id));
      // newScenario = designStore.saveNewConcreteScenario(getConcreteDesignFromR23Report(R, report));
      break;
    case 'Porous':
      console.log('Converting Porous');
      newScenario = designStore.saveNewPorousScenario(getPorousDesignFromR23Report(r23Metadata, r23Report, projectMetadata.id));
      break;
    case 'AC Overlay on Asphalt':
      console.log('Converting AC Overlay');
      newScenario = designStore.saveNewAcOverlayScenario(getAcOverlayDesignFromR23Report(r23Metadata, r23Report, projectMetadata.id));
      break;
    case 'Select a Project Type':
      console.log('incomplete');
      break;
  }

  // If a scenario was generated then the conversion was performed
  if (newScenario) {
    r23Metadata.conversion_done_design = true;
  } else {
    r23Metadata.conversion_done_design = false;
  }

  // await projectStore.updateLegacyReportMetadata(r23Metadata).then((result) => r23Metadata = result || r23Metadata);
  // }

  // Convert each scenario
  if (r23Report.scenarios !== undefined) {
    r23Report.scenarios.forEach((S: any) => {
      switch (S.scenariotype) {
        case 'Analyze Pavement Structure':
          console.log('Scenario:', S.scenariotype);
          r23Metadata.conversion_done_analyze = false;
          break;
        case 'Calculate Life-Cycle Cost':
          console.log('Scenario:', S.scenariotype);
          lccaStore.saveNewScenario(getLccaFromR23Report(r23Metadata, r23Report, projectMetadata.id));
          r23Metadata.conversion_done_lcca = true;
          break;
        case 'Estimate Material Cost':
          console.log('Scenario:', S.scenariotype);
          r23Metadata.conversion_done_other = false;
          break;
      }
    });
  }

  r23Metadata.conversion_complete = true;

  // await projectStore.updateLegacyReportMetadata(r23Metadata).then((result) => r23Metadata = result || r23Metadata);
};
